import { Grid, Box, Stack, useTheme } from '@ace-clublabs/shared-component-library';
import { BenefitLevel, FamilyMembers, RVMotorcycle } from './ManageMembershipItems';
import { ManageMembershipPriceCart } from './ManageMembershipPriceCart';
import { CindyBubble } from '../CindyBubble';
import { useEffect, useState } from 'react';

export const ManageMembershipSection = () => {
  const [boxHeight, setBoxHeight] = useState('auto');

  const updateBoxHeight = () => {
    const membershipSection = document.querySelector('.manage-membership-section') as HTMLElement;
    if (membershipSection) {
      setBoxHeight(`${membershipSection.offsetHeight}px`); // Set the blue box background height to the size of the container
    }
  };

  useEffect(() => {
    updateBoxHeight();
    window.addEventListener('resize', updateBoxHeight);
    return () => {
      window.removeEventListener('resize', updateBoxHeight);
    };
  }, []);

  const theme = useTheme();

  return (
    <Grid
      className="manage-membership-section"
      columns={12}
      container
      columnSpacing={'1.5rem'}
      sx={{ paddingBottom: '1rem' }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          backgroundColor: '#F7F8FA',
          zIndex: -1,
          width: '100vw',
          height: boxHeight,
        }}
      />
      <Grid size={{ xs: 12, sm: 12, md: 7, lg: 7 }} order={{ xs: 2, sm: 2, md: 1, lg: 1 }}>
        <Stack
          sx={{
            marginTop: '1.5rem',
            width: '100%',
            marginBottom: '7rem',
            [theme.breakpoints.up('sm')]: {
              marginBottom: 0,
            },
          }}
          gap="2rem"
        >
          <BenefitLevel />
          <FamilyMembers />
          <RVMotorcycle />
          <CindyBubble
            message="For any membership changes or cancellations that cannot be done online, please call us."
            className="manage-membership-page-cindy"
            id="manageMembershipPageCindy"
            buttons={[
              {
                id: 'manage-membership-cindy-call-button',
                buttonTitle: 'Call 1-844-786-1615',
                onClick: () => {
                  window.location.href = 'tel:+18447861615';
                },
              },
            ]}
          />
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5 }} order={{ xs: 1, sm: 1, md: 2, lg: 2 }}>
        <ManageMembershipPriceCart />
      </Grid>
    </Grid>
  );
};
